/* Organique r9 (29 Sep 2026): his answers of 29 Sep, 00:24 */
(function () {
  'use strict';
  var d = document;
  var isAr = (d.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  var SS = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- C11: the open search field on computers opens the theme's live search (with product suggestions) ---------- */
  (function () {
    var form = d.querySelector('[data-org-dsearch]');
    if (!form) return;
    var input = form.querySelector('input[type="search"]');
    if (!input) return;
    function openLive(text) {
      var modal = d.getElementById('search-modal');
      if (!modal || typeof modal.showDialog !== 'function') return false;
      try { modal.showDialog(); } catch (e) { return false; }
      var mi = modal.querySelector('input[type="search"], input[name="q"]');
      if (mi) {
        if (text) {
          mi.value = text;
          mi.dispatchEvent(new Event('input', { bubbles: true }));
        }
        setTimeout(function () { try { mi.focus(); var n = mi.value.length; mi.setSelectionRange(n, n); } catch (e) {} }, 30);
      }
      return true;
    }
    input.addEventListener('mousedown', function (e) {
      if (openLive('')) e.preventDefault();
    });
    input.addEventListener('input', function () {
      var v = input.value;
      if (v && openLive(v)) input.value = '';
    });
  })();

  /* ---------- C17: the set offer in the cart drawer, once per visit; "Switch to the set" swaps the parts for the set ---------- */
  (function () {
    var shownHere = {};
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var k = en.target.__orgSoKey;
        if (k) { shownHere[k] = true; SS.set(k, '1'); }
        io.unobserve(en.target);
      });
    }) : null;
    function apply() {
      each(d.querySelectorAll('[data-org-setoffer]'), function (box) {
        if (box.__orgSo) return;
        box.__orgSo = true;
        var key = 'org_setoffer_' + box.getAttribute('data-org-setoffer');
        if (SS.get(key) && !shownHere[key]) { box.hidden = true; return; }
        box.hidden = false;
        box.__orgSoKey = key;
        if (io) io.observe(box); else { shownHere[key] = true; SS.set(key, '1'); }
      });
    }
    apply();
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      (window.requestAnimationFrame || setTimeout)(function () { pending = false; apply(); });
    });
    mo.observe(d.body, { childList: true, subtree: true });

    d.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-org-so-switch]') : null;
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      var box = btn.closest('[data-org-setoffer]');
      if (!box) return;
      var vid = box.getAttribute('data-variant');
      var err = box.querySelector('.org-setoffer__err');
      var ups = (box.getAttribute('data-updates') || '').split(';').filter(Boolean).map(function (p) {
        var i = p.lastIndexOf('|');
        return { id: p.slice(0, i), quantity: parseInt(p.slice(i + 1), 10) || 0 };
      });
      btn.setAttribute('aria-busy', 'true');
      if (err) err.hidden = true;
      function fail() { btn.removeAttribute('aria-busy'); if (err) err.hidden = false; }
      function viaAjax() {
        var upd = {};
        ups.forEach(function (u) { upd[u.id] = u.quantity; });
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add');
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: upd })
          });
        }).then(function (r) {
          if (!r.ok) throw new Error('update');
          window.location.href = root + 'cart';
        }).catch(fail);
      }
      var actions = window.Shopify && window.Shopify.actions;
      if (actions && typeof actions.updateCart === 'function') {
        var lines = [{ merchandiseId: 'gid://shopify/ProductVariant/' + vid, quantity: 1 }].concat(ups.map(function (u) {
          return { id: u.id, quantity: u.quantity };
        }));
        actions.updateCart({ lines: lines }, { event: { context: 'cart' } }).then(function (res) {
          if (res && res.userErrors && res.userErrors.length) fail();
        }).catch(viaAjax);
      } else {
        viaAjax();
      }
    });
  })();

  /* ---------- C12: computers – the collection intro on one line with the same "Read more" toggle (button from organique-r6.js) ---------- */
  (function () {
    var desk = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: false };
    function fitAll() {
      if (!desk.matches) return;
      each(d.querySelectorAll('.org-coll__desc'), function (desc) {
        var btn = desc.querySelector('.org-readmore');
        if (!btn) return;
        if (desc.classList.contains('is-open')) { btn.hidden = false; return; }
        btn.hidden = true;
        btn.hidden = !(desc.scrollHeight > desc.clientHeight + 2);
      });
    }
    fitAll();
    window.addEventListener('resize', fitAll);
    window.addEventListener('load', fitAll);
    d.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.org-coll__desc .org-readmore') : null;
      if (b) setTimeout(fitAll, 0);
    });
  })();

  /* ---------- C14 / C20: Arabic "Buy it now" in the polite plural, like «أضيفوا إلى السلة» ---------- */
  if (isAr) {
    (function () {
      var from = 'شراء الآن';
      var to = 'اشتروا الآن';
      function fix(scope) {
        each((scope || d).querySelectorAll('.shopify-payment-button__button--unbranded'), function (b) {
          if (b.childElementCount === 0 && b.textContent.trim() === from) b.textContent = to;
        });
      }
      each(d.querySelectorAll('.shopify-payment-button'), function (wrap) {
        fix(wrap);
        new MutationObserver(function () { fix(wrap); }).observe(wrap, { childList: true, subtree: true, characterData: true });
      });
    })();
  }

  /* ---------- #37: product gallery – the photos after the first are lazy in the HTML (snippets/product-media.liquid),
     so on phones the first photo gets the whole connection; once the page has loaded they are warmed so swiping stays smooth ---------- */
  (function () {
    function warm() {
      each(d.querySelectorAll('media-gallery .product-media img[loading="lazy"]'), function (img) {
        if (img.closest('zoom-dialog')) return;
        img.loading = 'eager';
      });
    }
    function later() { setTimeout(warm, 200); }
    if (d.readyState === 'complete') later(); else window.addEventListener('load', later);
  })();
})();
